import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { storableError } from '../../util/errors';
import { getSupportedProcessesInfo } from '../../transactions/transaction';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';

const DASHBOARD_RECENT_BOOKINGS_LIMIT = 5;

const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));

const resolveOnlyFilter = currentUser => {
  const userType = currentUser?.attributes?.profile?.publicData?.userType;
  return userType === 'provider' ? 'sale' : 'order';
};

const loadDataPayloadCreator = (_, { getState, dispatch, rejectWithValue, extra: sdk }) => {
  const currentUser = getState()?.user?.currentUser;
  const only = resolveOnlyFilter(currentUser);
  const processNames = getSupportedProcessesInfo().map(p => p.name);
  const fromDate = new Date();
  fromDate.setDate(fromDate.getDate() - 30);

  const apiQueryParams = {
    only,
    processNames,
    bookingStart: `${fromDate.toISOString()},`,
    sort: 'createdAt',
    include: [
      'listing',
      'provider',
      'provider.profileImage',
      'customer',
      'customer.profileImage',
      'booking',
    ],
    'fields.transaction': [
      'state',
      'processName',
      'lastTransition',
      'lastTransitionedAt',
      'transitions',
      'payinTotal',
      'payoutTotal',
      'lineItems',
      'metadata',
      'protectedData',
    ],
    'fields.listing': ['title', 'availabilityPlan', 'publicData.listingType'],
    'fields.user': ['profile.displayName', 'profile.abbreviatedName', 'deleted', 'banned'],
    'fields.image': ['variants.square-small', 'variants.square-small2x'],
    perPage: DASHBOARD_RECENT_BOOKINGS_LIMIT,
    page: 1,
  };

  return sdk.transactions
    .query(apiQueryParams)
    .then(response => {
      console.log('response', response);
      dispatch(addMarketplaceEntities(response));
      return response;
    })
    .catch(e => rejectWithValue(storableError(e)));
};

export const loadDataThunk = createAsyncThunk('DashboardPage/loadData', loadDataPayloadCreator);

const dashboardPageSlice = createSlice({
  name: 'DashboardPage',
  initialState: {
    fetchInProgress: false,
    fetchDashboardDataError: null,
    transactionRefs: [],
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(loadDataThunk.pending, state => {
        state.fetchInProgress = true;
        state.fetchDashboardDataError = null;
      })
      .addCase(loadDataThunk.fulfilled, (state, action) => {
        const transactions = action.payload?.data?.data || [];
        state.fetchInProgress = false;
        state.transactionRefs = entityRefs(transactions);
      })
      .addCase(loadDataThunk.rejected, (state, action) => {
        console.error(action.payload || action.error); // eslint-disable-line
        state.fetchInProgress = false;
        state.fetchDashboardDataError = action.payload;
      });
  },
});

export default dashboardPageSlice.reducer;

export const loadData = () => dispatch => {
  return dispatch(loadDataThunk());
};
